<div class="parallax_group content">
    <div class="container" id="sourceCode">
        <a [routerLink]="['']">
            <code [innerHTML]="swiftCode"></code>
        </a>
    </div>
</div>